import { Plus, Loader2 } from "lucide-react";
import { useNavigate } from "react-router";
import { useBloodTestPackages, useCreateBloodTestPackage } from "@/hooks/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function PackagesPage() {
  const { data: packages, isLoading } = useBloodTestPackages();
  const createPackage = useCreateBloodTestPackage();
  const navigate = useNavigate();

  const handleCreate = async () => {
    const pkg = await createPackage.mutateAsync({ name: "Ny pakke", description: "", priceInNok: "0" });
    navigate(`/packages/${pkg.id}`);
  };

  if (isLoading) {
    return <div className="flex items-center justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-admin-text-subtle" /></div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">Pakker</h2>
        <Button onClick={handleCreate} size="sm" disabled={createPackage.isPending}>
          <Plus className="h-4 w-4" />
          Ny pakke
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {(packages ?? []).map((pkg) => (
          <Card
            key={pkg.id}
            className="cursor-pointer hover:border-admin-primary/50 transition-colors"
            onClick={() => navigate(`/packages/${pkg.id}`)}
          >
            <CardContent className="p-4 space-y-2">
              <div className="flex items-start justify-between">
                <h3 className="font-semibold">{pkg.name}</h3>
                {pkg.priceInNok && (
                  <span className="text-sm text-admin-primary font-medium">{pkg.priceInNok} kr</span>
                )}
              </div>
              {pkg.description && (
                <p className="text-sm text-admin-text-secondary line-clamp-2">{pkg.description}</p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
